import React, { useEffect } from "react";

import { Route, BrowserRouter as Router } from "react-router-dom";
import Dashboard from "../../Pages/Dashboard/Dashboard";
import InstituteView from "../../Pages/Institute/InstituteView";
import Student from "../../Pages/Student/Student";
import Login from "../../components/Login/Login";
import Signup from "../../Pages/signup/signup";
import CourseView from "../../Pages/Courses/CourseView/CourseView";
import TestSeriesAddEdit from "../../Pages/Courses/CourseView/CourseTestSeries/TestSeriesAddEdit";
import InstituteCourse from "../../Pages/Courses/InstituteCourse";
import Transactions from "../../Pages/Transactions/Transactions";
import Feeds from "../../Pages/Feeds/feeds";
import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import InstituteEdit from "../../Pages/Institute/InstituteEdit";
import InstitutePayout from "../../Pages/Institute/InstitutePayout/InstitutePayout";
import StudentView from "../../Pages/Courses/CourseView/EnrolledStudents/StudentView";
import LeaderBoard from "../../Pages/Leaderboard/LeaderBoard";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  SET_AUTH_STATUS,
  SET_INSTITUTE_ACCESS_TOKEN,
  SET_INSTITUTE_DETAILS,
} from "../../Reducers/types";
import Notification from "../../Pages/Notification/Notification";
import StudentChat from "../../Pages/Courses/CourseView/StudentChat/StudentChat";

// import { validateLogin } from '../../api/login'
import ResetPassword from "../../Pages/ResetPassword/ResetPassword";
import ForgotPassword from "../../Pages/ForgotPassword/ForgotPassword";

import Header from "../header/header";
import Loader from "../Loader/Loader";
import TestSeries from "../../Pages/TestSeries/TestSeries/TestSeries";
import AddEditTestSeries from "../../Pages/TestSeries/TestSeries/AddEditTestSeries";
import TestSeriesListing from "../../Pages/TestSeries/TestSeries/TestSeriesListing";
import Category from "../../Pages/TestSeries/Category/Category";
import SubCategory from "../../Pages/TestSeries/SubCategory/SubCategory";
import { validateAccessToken } from "../../api/login";
import CategoryStats from "../../Pages/TestSeries/Category/CategoryStats";
import SubCategoryStats from "../../Pages/TestSeries/SubCategory/SubCategoryStats";
import TestSeriesDashboard from "../../Pages/TestSeries/TestSeries/TestSeriesDashboard";
import CategoryChapters from "../../Pages/TestSeries/Category/CategoryChapters";
import CategoryTopics from "../../Pages/TestSeries/Category/CategoryTopics";
import CategorySubTopics from "../../Pages/TestSeries/Category/CategorySubTopics";
import CategorySubSubTopics from "../../Pages/TestSeries/Category/CategorySubSubTopics";
import Interns from "../../Pages/TestSeries/Interns/Interns";
import CategoryBooks from "../../Pages/TestSeries/Category/CategoryBooks";
import ReferEarn from "../../Pages/TestSeries/Refer&Earn/ReferEarn";
import ReferEarnLeaderboard from "../../Pages/TestSeries/Refer&EarnLeaderboard/ReferEarnLeaderboard";
import EachReferEarn from "../../Pages/TestSeries/EachRefer&Earn/EachReferEarn";
import QuestionReportSystem from "../../Pages/TestSeries/QuestionReportSystem/QuestionReportSystem";
import Troubleshoot from "../../Pages/Toubleshoot/Troubleshoot";

const routerSwitch = (authStatus) => {
  return (
    <>
      <Route exact path="/" component={Login} />

      <Route exact path="/signup" authStatus={authStatus} component={Signup} />
      <Route
        exact
        path="/reset-password/:hash1/:hash2"
        authStatus={authStatus}
        component={ResetPassword}
      />
      <Route
        exact
        path="/forgot-password"
        authStatus={authStatus}
        component={ForgotPassword}
      />

      <PrivateRoute
        exact
        path="/dashboard"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <Dashboard {...props} />
          </>
        )}
      />

      <PrivateRoute
        exact
        path="/troubleshoot"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <Troubleshoot {...props} />
          </>
        )}
      />
      <PrivateRoute
        exact
        path="/subcategory/:categoryId/:categoryName"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <SubCategory {...props} />
          </>
        )}
      />
      <PrivateRoute
        exact
        path="/subcategoryStats/:id"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <SubCategoryStats {...props} />
          </>
        )}
      />
      <PrivateRoute
        exact
        path="/testseriesStat/:id"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <TestSeriesDashboard {...props} />
          </>
        )}
      />
      <PrivateRoute
        exact
        path="/mocktest"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <Category {...props} />
          </>
        )}
      />

      <PrivateRoute
        exact
        path="/mocktestStats/:id"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <CategoryStats {...props} />
          </>
        )}
      />
      <PrivateRoute
        exact
        path="/chapters/:id"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <CategoryChapters {...props} />
          </>
        )}
      />
      <PrivateRoute
        exact
        path="/books/:id"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <CategoryBooks {...props} />
          </>
        )}
      />
      <PrivateRoute
        exact
        path="/topics/:id"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <CategoryTopics {...props} />
          </>
        )}
      />
      <PrivateRoute
        exact
        path="/subtopics/:id"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <CategorySubTopics {...props} />
          </>
        )}
      />

      <PrivateRoute
        exact
        path="/subsubtopics/:id"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <CategorySubSubTopics {...props} />
          </>
        )}
      />
      <PrivateRoute
        path="/listing/:subCatId/:subCatName/:catId/:catName"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <TestSeriesListing {...props} />
          </>
        )}
      />
      <PrivateRoute
        exact
        path="/testseries/:testSeriesId"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <TestSeries {...props} />
          </>
        )}
      />
      <PrivateRoute
        exact
        path="/testseries/addedit"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <AddEditTestSeries {...props} />
          </>
        )}
      />

      <PrivateRoute
        exact
        path="/feeds/:type"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <Feeds {...props} />
          </>
        )}
      />

      <PrivateRoute
        exact
        path="/instituteProfile"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <InstituteView {...props} />
          </>
        )}
      />
      <PrivateRoute
        exact
        path="/student/list"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <Student {...props} />
          </>
        )}
      />
      <PrivateRoute
        exact
        path="/insCourses/:isDeleted"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <InstituteCourse {...props} />
          </>
        )}
      />
      <PrivateRoute
        exact
        path="/notification/"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <Notification {...props} />
          </>
        )}
      />
      <PrivateRoute
        exact
        path="/addTestSeries/:type/:seriesId/:activeCourse"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <TestSeriesAddEdit {...props} />
          </>
        )}
      />
      <PrivateRoute
        exact
        path="/ins/course/courseview/:id/:name"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <CourseView {...props} />
          </>
        )}
      />
      {/* <PrivateRoute
        exact
        path="/studentView/:id"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <StudentView {...props} />
          </>
        )}
      /> */}
      {/* <PrivateRoute
        exact
        path="/instituteEdit"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <InstituteEdit {...props} />
          </>
        )}
      /> */}

      {/* <PrivateRoute
        exact
        path="/transactions/:status"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <Transactions {...props} />
          </>
        )}
      /> */}

      {/* <PrivateRoute
        exact
        path="/institutePayout"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <InstitutePayout {...props} />
          </>
        )}
      /> */}
      {/* <PrivateRoute
        exact
        path="/leaderboard/:id"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <LeaderBoard {...props} />
          </>
        )}
      /> */}
      {/* <PrivateRoute
        exact
        path="/studentChat/:courseId"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <StudentChat {...props} />
          </>
        )}
      /> */}
      {/* <PrivateRoute
        exact
        path="/studentChat/:courseId/:studentId"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <StudentChat {...props} />
          </>
        )}
      /> */}

      {/* <PrivateRoute
        exact
        path="/interns"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <Interns {...props} />
          </>
        )}
      /> */}

      {/* <PrivateRoute
        exact
        path="/referearn"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <ReferEarn {...props} />
          </>
        )}
      /> */}

      {/* <PrivateRoute
        exact
        path="/referearnleaderboard"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <ReferEarnLeaderboard {...props} />
          </>
        )}
      /> */}
      {/* 
      <PrivateRoute
        exact
        path="/referals/:id/:referrerid"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <EachReferEarn {...props} />
          </>
        )}
      /> */}

      {/* Question Report System Data */}
      <PrivateRoute
        exact
        path="/questionReportSystemData"
        authStatus={authStatus}
        render={(props) => (
          <>
            <Header />
            <QuestionReportSystem {...props} />
          </>
        )}
      />
    </>
  );
};

const PrivateRoute = ({ render: Component, authStatus, ...rest }) => {
  return (
    // restricted = false meaning public route
    // restricted = true meaning restricted route
    <Route
      {...rest}
      render={(props) =>
        authStatus ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
};
const Routes = (props) => {
  const authStatus = useSelector((state) => state.ins.authStatus);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    verifyInsLogin();
  }, []);

  const verifyInsLogin = async () => {
    setLoading(true);
    const insAccessToken = localStorage.getItem("ins_token");
    if (insAccessToken != null) {
      const response = await validateAccessToken(insAccessToken);
      if (response.status) {
        dispatch({ type: SET_AUTH_STATUS, payload: { authStatus: true } });
        dispatch({
          type: SET_INSTITUTE_DETAILS,
          payload: { insDetails: response.data.data },
        });
        dispatch({
          type: SET_INSTITUTE_ACCESS_TOKEN,
          payload: { accessToken: insAccessToken },
        });
        setLoading(false);
      }
    }
    setLoading(false);
  };

  return loading ? (
    <div
      style={{
        display: "flex",
        height: "100vh",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* <ClipLoader color={"#673ab7"} loading={loading}   size={50} /> */}
      <Loader height={80} width={80} />
    </div>
  ) : authStatus ? (
    <div className="page-wrapper">
      <div className="page-content-wrapper">
        <div className="page-content">{routerSwitch(authStatus)}</div>
      </div>
    </div>
  ) : (
    routerSwitch(authStatus)
  );
};

export default Routes;
